import { render, staticRenderFns } from "./opcionMultipleUnaRespuesta.vue?vue&type=template&id=1408df74&scoped=true&"
import script from "./opcionMultipleUnaRespuesta.vue?vue&type=script&lang=js&"
export * from "./opcionMultipleUnaRespuesta.vue?vue&type=script&lang=js&"
import style0 from "./opcionMultipleUnaRespuesta.vue?vue&type=style&index=0&id=1408df74&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1408df74",
  null
  
)

export default component.exports